import {collection, component, dateField, EntityData, field, identifier} from "@fedeltapointofsale/data-client";
import {AccountReferenceData} from "../account/account-reference.data";
import {PaymentChargeLinkData} from "./account-charge-link.data";


export class AccountPaymentDetailsData extends EntityData<AccountPaymentDetailsData> {

    @field paymentAmt: number;
    @field creditAmt: number;
    @field creditAmountDiscountPercent: number;
    @field reference: string;
    /**
     * Payment details (e.g. Cash, Visa, etc)
     */
    @field details: string;
    @dateField paymentDate: Date;
    @field outletId: number;
    @field outletName: string;
    @field receiptNo: string;
}

export class AccountPaymentData extends EntityData<AccountPaymentData> {
    @identifier paymentId: number;
    @component account: AccountReferenceData;
    @component details: AccountPaymentDetailsData;
    @collection(PaymentChargeLinkData) chargePayments: PaymentChargeLinkData[];

    @field type: string;
    @field status: string;
}
